import React from "react";
import { NewLessonsProvider } from "./NewLessonContext";
import NewLessonsEntry from "./NewLessonEntry";

const NewLessonsOptimized = () => {
  return (
    <NewLessonsProvider>
      <NewLessonsEntry />
    </NewLessonsProvider>
  );
};

export default NewLessonsOptimized;
